import React, { useState, useEffect } from 'react';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import NovaPrefeitura from './NovaPrefeitura';
import FichaPrefeitura from './FichaPrefeitura';

// api
import prefeitura_api from '../../../api/prefeitura_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

export default function Prefeituras({ permissao }) {
    //Guarda a lista de prefeituras
    const [prefeituras, setPrefeituras] = useState([]);

    //Controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da tela de nova prefeitura
    const [novaPrefeitura, setNovaPrefeitura] = useState(false);

    //Estado de controle para a ficha da prefeitura selecionada
    const [fichaPrefeitura, setFichaPrefeitura] = useState(null);

    //Função do clique do botão de editar prefeitura
    const editar = (item) => setFichaPrefeitura(item.id);

    //Função do clique do botão de adicionar
    const nova = () => setNovaPrefeitura(true);

    //Função do botão de voltar
    const btnVoltar = () => {
        loadPrefeituras();
        setNovaPrefeitura(false);
        setFichaPrefeitura(null);
    }

    //Cabeçalhos da tabela de listagem de prefeituras
    const headers = [
        { value: "Identificação", objectValue: "fantasia", align: "left" },
        { value: "Município", objectValue: "cidade", align: "left" },
        { value: "Estado", objectValue: "status", align: "left" }
    ]

    //Carrega todas a lista de prefeituras
    const loadPrefeituras = () => {
        setLoading(true);
        prefeitura_api.GetList().then(response => {
            setPrefeituras(response.data);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        });
    }

    //Variavel que guarda as ações da tabela 
    const actions = [];
    actions.push(actionsTable.visualizar(editar));

    //Carrega a lista de prefeituras assim que o componente é inicializada
    useEffect(() => {
        loadPrefeituras();
    }, [])

    //Controle da exibição da tela de nova prefeitura 
    if (novaPrefeitura) {
        return <NovaPrefeitura loading={loading} setLoading={setLoading} btnVoltar={btnVoltar} />
    }

    //Controle da exibição da ficha da prefeitura selecionada
    if (fichaPrefeitura) {
        return <FichaPrefeitura loading={loading} setLoading={setLoading} id={fichaPrefeitura} btnVoltar={btnVoltar} permissao={permissao} />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={nova}>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de prefeituras"} options={{ print: false, search: true, pagination: true }} headers={headers} items={prefeituras} />
                </div>
            </MainCard>
        </>
    )
}
